<div
  [ngClass]="{
    'toast-show':showToast,
    'toast-success': success,
    'toast-warning': warning,
    'toast-error': error
  }"
  class="toast-message"
>
  {{ message }}
</div>
